const audioMap = new Map<string, HTMLAudioElement>();

export const isAudioAvailable = (id: string) => {
  return audioMap.has(id);
};

export const addAudio = (id: string, url: string) => {
  const audio = new Audio(url);
  audioMap.set(id, audio);
};

export const pauseAudioForMessage = (id: string) => {
  const audio = audioMap.get(id);
  audio?.pause();
};

export const pauseAllAudios = () => {
  audioMap.forEach(audio => {
    audio.pause();
  });
};

export const playAudioForMessage = (id: string, onEnded: () => void) => {
  pauseAllAudios();

  const audio = audioMap.get(id);

  if (!audio) {
    return;
  }

  audio.onended = () => {
    onEnded();
  };
  audio.play();
};
